import * as Configuration from '../../app.constants.js';

/**
 * All functions are used after old inbox remove
 */
export class MessagesService {

  sites = [];

  constructor($http, $mdDialog, UserFactory, ParametersFactory, AlertingFactory, ExternalUserFactory, AngularOptinsService) {
    this.$http = $http;
    this.$mdDialog = $mdDialog;
    this.UserFactory = UserFactory;
    this.ParametersFactory = ParametersFactory;
    this.AlertingFactory = AlertingFactory;
    this.ExternalUserFactory = ExternalUserFactory;
    this.AngularOptinsService = AngularOptinsService;
  }

  action(companyId, messageId, siteId, actionType, taskId) {
    return this.$http({
      url: Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/messages/' + messageId + '/actions/',
      method: 'POST',
      data: {
        action_type: actionType,
        task_id: taskId,
        site_id: siteId
      },
    });
  }

  listActions(companyId, messageId, siteId) {
    return this.$http({
      url: Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/messages/' + messageId + '/actions-allowed',
      method: 'GET',
      params: {
        refresh_site_id: siteId
      },
    });
  }

  /**
   * Show the profil modal
   */
  showUserInteractions(companyId, siteId, userId, avatarUrl, taskId, selectedOrgId) {
    this.$mdDialog.show({
      controller: 'UserInteractionsMaterialController',
      template: require('../user/user-interactions-material.html'),
      clickOutsideToClose: true,
      locals: {
        loggedUser: this.UserFactory.getLoggedUser(),
        siteId: siteId,
        userId: userId,
        avatarUrl: avatarUrl,
        openedFromTaskId: taskId,
        selectedOrgId: selectedOrgId,
      },
      resolve: {
        sites: () => this.sites,
        linkedUsersAnCrmfOrgs: () => this.ExternalUserFactory.getLinkedUsersAndCrmOrgs(companyId, siteId, userId)
          .then(
            response => {
              // necessary for the tabs, despite <angular-crm-organizations-linked> can be used to display data (but not enabled)
              response.data.crm_orgs = (response.data.crm_orgs || []).filter(org => {
                return org.linked_sites.some(
                  linkedSite => linkedSite.site_id === siteId && linkedSite.is_active
                );
              });
              return response.data;
            },
            () => this.AlertingFactory.errorAndReturnRejectedPromise('task_template/see_profile_fail')),
        userOptins: () => this.AngularOptinsService.getUserOptins(userId).toPromise()
      }
    });
  }

  static MessagesFactory($http, $mdDialog, UserFactory, ParametersFactory, AlertingFactory, ExternalUserFactory, AngularOptinsService) {
    return new MessagesService($http, $mdDialog, UserFactory, ParametersFactory, AlertingFactory, ExternalUserFactory, AngularOptinsService);
  }
}
MessagesService.MessagesFactory.$inject = ['$http', '$mdDialog', 'UserFactory', 'ParametersFactory', 'AlertingFactory', 'ExternalUserFactory', 'AngularOptinsService'];
